import { Box, Card, CardContent, List, ListItem, ListItemText, SvgIcon, Typography } from "@mui/material";
import { ICatalogOffer } from "@features/cart/ICart";
import { useStyle } from "./style";
import { useTranslation } from "react-i18next";
import { OfferPrice } from "@common/OfferPrice/OfferPrice";
import { Check } from "@mui/icons-material";
import { IFetchState } from "itsf-ui-common";
import { Error } from "@common/HandleErrorAndLoading/Error";
import { ReactNode } from "react";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";
import { BUTTON_IDS } from "@features/dataLayer/buttonIds";
import LockIcon from "@static/icons/Lock.svg";

interface IParams {
    price: number;
    offer: ICatalogOffer;
    handleClickBuyNow(): void;
    isOfferAlreadyAdded?: boolean;
    offerAlreadyAddedText: string;
    addOfferState: IFetchState;
    additionalInfoComponent?: ReactNode;
    isSidePanel?: boolean;
}

export const OfferCard = (props: IParams) => {
    const {
        price,
        offer,
        handleClickBuyNow,
        addOfferState,
        isOfferAlreadyAdded,
        offerAlreadyAddedText,
        additionalInfoComponent,
        isSidePanel,
    } = props;
    const { t } = useTranslation(["home", "glossary"]);
    const { classes } = useStyle();

    return (
        <Card className={classes.card} elevation={2}>
            <CardContent>
                <Box alignItems="center" display="flex" flexDirection="column">
                    <Typography color="secondary" paddingBottom={3} variant="h2">
                        {offer.description}
                    </Typography>
                    <OfferPrice price={price} priceColor="#33A1A9" />
                    <Box paddingY={3} textAlign="left">
                        <Box alignItems="center" display="flex">
                            <SvgIcon
                                className={classes.offerIcon}
                                color="primary"
                                component={LockIcon}
                                inheritViewBox
                            />
                            <Typography className={classes.firstUsageDescription} color="secondary">
                                {offer.usages[0]?.description}
                            </Typography>
                        </Box>
                        <List className={classes.list}>
                            {offer.usages.slice(1).map((usage, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <ListItem className={classes.listItem} key={index}>
                                    <ListItemText
                                        primary={usage.description}
                                        primaryTypographyProps={{ margin: 0, variant: "normal" }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                    {additionalInfoComponent}
                    <LabeledButton
                        className={classes.button}
                        color="primary"
                        disabled={addOfferState.isLoading}
                        id={
                            isSidePanel
                                ? BUTTON_IDS.MOBILE_FLOW.DRAWER_CTA.BUY_BROADBAND
                                : BUTTON_IDS.BROADBAND_FLOW.ADD_TO_CART_CTA.BUY_BROADBAND
                        }
                        labelText={isOfferAlreadyAdded ? offerAlreadyAddedText : t("home:buyBroadband")}
                        startIcon={isOfferAlreadyAdded && <Check />}
                        onClick={() => !isOfferAlreadyAdded && handleClickBuyNow()}
                    >
                        {isOfferAlreadyAdded ? offerAlreadyAddedText : t("home:buyBroadband")}
                    </LabeledButton>
                    {offer.activationFee && (
                        <Typography color="secondary" marginY={2} variant="small">
                            {t("glossary:activationFee", { price: offer.activationFee })}
                        </Typography>
                    )}
                    {addOfferState.error && (
                        <Box paddingTop={4}>
                            <Error error={addOfferState.error} />
                        </Box>
                    )}
                </Box>
            </CardContent>
        </Card>
    );
};
